import {
  V2Tooltip,
  AlertTriangleIcon,
  WarningCircleIcon,
  CheckCircleFillIcon,
} from "@stacklet/ui";

interface Props {
  status: "success" | "warning" | "error";
  message?: string;
}

export function StatusIcon({ status, message }: Props) {
  return (
    <>
      {status === "error" ? (
        <V2Tooltip title={message || ""}>
          <WarningCircleIcon
            aria-label="error"
            className="mx-xxs size-icon-s fill-negative-600"
            data-testid="error-icon"
          />
        </V2Tooltip>
      ) : null}
      {status === "warning" ? (
        <V2Tooltip title={message || ""}>
          <AlertTriangleIcon
            aria-label="warning"
            className="mx-xxs size-icon-s text-warning-700"
            data-testid="warning-icon"
          />
        </V2Tooltip>
      ) : null}

      {status === "success" ? (
        <div>
          <CheckCircleFillIcon
            aria-label="success"
            className="mx-xxs size-icon-l text-positive-700"
          />
        </div>
      ) : null}
    </>
  );
}
